
<div class="new-comers-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12">
                <div class="new-comers-content">
                    <h3>Ils parlent de nous</h3>
                    <h4 class="dash"></h4>
                    <p class="mission-text">Offrir, par le professionnalisme et le dévouement de nos équipes,
                         des solutions dynamiques et innovantes en éducation, formation et
                          coaching, en vue de fournir au client, COMPETENCES, MÉCANISME et
                           MODELE et participant ainsi au développement social,
                         économique des personnes, des organisations et des communautés.</p>
                    <div class="new-comers-btn">
                        <a routerLink="/about-style-1" class="default-btn abt-btn">
                            <i class='bx bx-move-horizontal icon-arrow before'></i>
                            <span class="label">J'inscris mon enfant</span>
                            <i class="bx bx-move-horizontal icon-arrow after"></i>
                        </a>
                    </div>
                    <!-- <blockquote class="wp-block-quote">
                        <p style="text-align: justify;" > « L'éducation est plus qu'un métier, c'est une mission, qui consiste à aider chaque personne à reconnaitre ce qu'elle a d'irremplaçable et d'unique, afin qu'elle grandisse et s'épanouisse. »</p>
                        <i style="position: absolute; right: 0; color: #ff6e1c; padding-bottom: 10px">Pape Saint Jean Paul II</i>
                    </blockquote> -->
                </div>
            </div>
        </div>
    </div>

    <section class="testimonials">
        <div class="container">
            <div class="row text-center">
                <div class="col-md-12">
                    <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                        <!-- Indicators-->
                        <ol class="carousel-indicators">
                            <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                            <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                        </ol>

                        <div class="">
                            <!-- Item-1 -->
                            <div class="carousel-item active text-center">
                                <img src="https://i.ibb.co/8x9xK4H/team.jpg" alt="" class="center-block team">
                                <h3>Alamin Musa</h3>
                                <h4>Front End Developer</h4>
                                <p class="mission-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
                                    porttitordapibus dictum.<br>
                                    Fusce faucibus ligula scelerisque, eleifend turpis in</p>
                            </div>
                            <!-- Item-2 -->
                            <div class="carousel-item text-center">
                                <img src="https://i.ibb.co/8x9xK4H/team.jpg" alt="" class="center-block team">
                                <h3>Alamin Musa</h3>
                                <h4>Front End Developer</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
                                    porttitordapibus dictum.<br>
                                    Fusce faucibus ligula scelerisque, eleifend turpis in</p>
                            </div>
                            <!-- Item-3 -->
                            <div class="carousel-item text-center">
                                <img src="https://i.ibb.co/8x9xK4H/team.jpg" alt="" class="center-block team">
                                <h3>Alamin Musa</h3>
                                <h4>Front End Developer</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
                                    porttitordapibus dictum.<br>
                                    Fusce faucibus ligula scelerisque, eleifend turpis in</p>
                            </div>

                        </div>
                        <a
                            class="carousel-control-prev control"
                            data-target="#carouselExampleIndicators"
                            role="button"
                            data-slide="prev">
                            <span class="fa fa-angle-left icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a
                            class="carousel-control-next control"
                            data-target="#carouselExampleIndicators"
                            role="button"
                            data-slide="next">
                            <span class="fa fa-angle-right icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>









